import React from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <section className="contact py-80">
      <div className="container container-lg">
        <div className="row gy-5">
          <div className="col-lg-12">
            <div
              className="contact-box px-24 py-40 refund-content"
              style={{ lineHeight: "1.8" }}
            >
              <style>{`
                .refund-content h1,
                .refund-content h2,
                .refund-content h3,
                .refund-content h4,
                .refund-content h5,
                .refund-content h6 {
                  font-size: 28px;
                  margin-top: 20px;
                  margin-bottom: 20px;
                  font-weight: 600;
                }
                .refund-content p {
                  margin-bottom: 15px;
                }
                .refund-content a {
                  color: #007bff;
                  text-decoration: none;
                }
                .refund-content a:hover {
                  text-decoration: underline;
                }
              `}</style>

              <h2>RETURN POLICY</h2>
              <p>
                <strong>Last updated November 03, 2025</strong>
              </p>

              <p>
                Thank you for your purchase. We hope you are happy with your
                purchase. However, if you are not completely satisfied with your
                purchase for any reason, you may return it to us for a refund,
                store credit, or an exchange. Please see below for more
                information on our return policy.
              </p>

              <h3>RETURNS</h3>
              <p>
                All returns must be postmarked within fourteen (14) days of the
                purchase date. All returned items must be in new and unused
                condition, with all original tags and labels attached.
              </p>

              <h3>RETURN PROCESS</h3>
              <p>
                To return an item, please email customer service at{" "}
                <a href="mailto:info@printingdealz.com">
                  info@printingdealz.com
                </a>{" "}
                to obtain a Return Merchandise Authorisation (RMA) number. After
                receiving an RMA number, place the item securely in its original
                packaging and include your proof of purchase, then mail your
                return to the following address:
              </p>

              <p>
                <strong>PrintingDealz</strong>
                <br />
                Attn: Returns
                <br />
                RMA #<br />
                9200 2nd Av SW, #204A
                <br />
                Seattle, WA 98106
                <br />
                United States
              </p>

              <p>Return shipping charges will be paid or reimbursed by us.</p>

              <h3>REFUNDS</h3>
              <p>
                After receiving your return and inspecting the condition of your
                item, we will process your return or exchange. Please allow at
                least seven (7) days from the receipt of your item to process
                your return or exchange. Refunds may take 1–2 billing cycles to
                appear on your credit card statement, depending on your credit
                card company. We will notify you by email when your return has
                been processed.
              </p>

              <h3>EXCEPTIONS</h3>
              <p>
                For defective or damaged products, please contact us at the
                contact details below to arrange a refund or exchange.
              </p>

              <h3>QUESTIONS</h3>
              <p>
                If you have any questions concerning our return policy, please
                contact us at:
              </p>

              <p>
                <strong>Phone:</strong> +1-206-466-6995
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:info@printingdealz.com">
                  info@printingdealz.com
                </a>
                <br />
                <strong>Address:</strong> 9200 2nd Av SW, #204A, Seattle, WA,
                98106, United States
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
